// Order Status Constants - matches API response format (capitalized)
export const OrderStatus = [
  'Working',
  'Traded',
  'Reverted',
  'Expired',
  'Cancelled',
  'Pending',
  'Scheduled',
] as const;

export type OrderStatusType = (typeof OrderStatus)[number];

// Status constants for easy comparison (derived from OrderStatus array)
export const ORDER_STATUS = {
  WORKING: OrderStatus[0],
  TRADED: OrderStatus[1],
  REVERTED: OrderStatus[2],
  EXPIRED: OrderStatus[3],
  CANCELLED: OrderStatus[4],
  PENDING: OrderStatus[5],
  SCHEDULED: OrderStatus[6],
} as const;

// Lowercase versions for filters/queries
export const OrderStatusLowercase = [
  'working',
  'traded',
  'reverted',
  'expired',
  'cancelled',
  'pending',
  'scheduled',
] as const;

// Backend API Status IDs
export const PENDING_STATUS_ID = 20006;
export const WORKING_STATUS_ID = 20000;
